var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 70,
    viewBox: "0 0 44 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6976 29.6867C14.6677 29.6867 8.14062 23.1597 8.14062 15.1297C8.14062 7.09976 14.6677 0.529785 22.6976 0.529785C30.7276 0.529785 37.2546 7.05682 37.2546 15.0868C37.2546 23.1168 30.7276 29.6867 22.6976 29.6867ZM22.6976 8.86034C19.2623 8.86034 16.4712 11.6515 16.4712 15.0868C16.4712 18.5221 19.2623 21.3132 22.6976 21.3132C26.1329 21.3132 28.9241 18.5221 28.9241 15.0868C28.9241 11.6515 26.1329 8.86034 22.6976 8.86034Z",
    fill: "#05051E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8384 69.2351L24.4161 48.1511C23.2567 50.8134 21.7538 53.304 19.9073 55.5798C15.4415 60.9904 9.21501 64.8551 2.30151 66.4439L0.412109 58.3281C5.4362 57.1686 9.98795 54.3345 13.2515 50.384C16.6009 46.3046 18.4044 41.3234 18.4044 36.0417L26.3914 34.0664L43.3531 65.2845L35.8384 69.2351Z",
    fill: "#05051E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogoBlack);
export default __webpack_public_path__ + "static/media/small-logo-black.98d81752a1c4802c236222f51606fda1.svg";
export { ForwardRef as ReactComponent };